import React from "react";
import { Accordion } from "react-bootstrap";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";

const SubAdmin = ({ setShowSidebar }) => {
  const PERMISSIONS = useSelector(
    (s) => s?.Signatures?.adminDetail?.data?.permissions || [],
  );

  const closeSidebar = () => {
    setShowSidebar(false);
  };

  const navClass = ({ isActive }) =>
    `link d-flex align-items-center ${isActive ? "active" : ""}`;

  const subNavClass = ({ isActive }) =>
    `d-flex align-items-center ${isActive ? "active" : ""}`;
  console.log(PERMISSIONS, "PERMISSIONS");
  return (
    <ul className="list-unstyled mb-0 w-100 sidebar-links">
      {/* CLIENT ACCOUNTS */}
      {PERMISSIONS.includes("accounts") && (
        <li>
          <NavLink to="/customers" onClick={closeSidebar} className={navClass}>
            <span className="me-2 icn">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M12 2C10.6868 2 9.38642 2.25866 8.17317 2.7612C6.95991 3.26375 5.85752 4.00035 4.92893 4.92893C3.05357 6.8043 2 9.34784 2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C5.85752 19.9997 6.95991 20.7362 8.17317 21.2388C9.38642 21.7413 10.6868 22 12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7362 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2M7.07 18.28C7.5 17.38 10.12 16.5 12 16.5C13.88 16.5 16.5 17.38 16.93 18.28C15.5294 19.396 13.7909 20.0026 12 20C10.14 20 8.43 19.36 7.07 18.28ZM18.36 16.83C16.93 15.09 13.46 14.5 12 14.5C10.54 14.5 7.07 15.09 5.64 16.83C4.57618 15.4446 3.99967 13.7467 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 13.82 19.38 15.5 18.36 16.83M12 6C10.06 6 8.5 7.56 8.5 9.5C8.5 11.44 10.06 13 12 13C13.94 13 15.5 11.44 15.5 9.5C15.5 7.56 13.94 6 12 6ZM12 11C11.6022 11 11.2206 10.842 10.9393 10.5607C10.658 10.2794 10.5 9.89782 10.5 9.5C10.5 9.10218 10.658 8.72064 10.9393 8.43934C11.2206 8.15804 11.6022 8 12 8C12.3978 8 12.7794 8.15804 13.0607 8.43934C13.342 8.72064 13.5 9.10218 13.5 9.5C13.5 9.89782 13.342 10.2794 13.0607 10.5607C12.7794 10.842 12.3978 11 12 11Z"
                  fill="black"
                />
              </svg>
            </span>
            Client Accounts
          </NavLink>
        </li>
      )}

      {/* FINANCIAL QUESTIONNAIRE */}
      {PERMISSIONS.includes("financial_configure") && (
        <li>
          <Accordion flush>
            <Accordion.Item eventKey="finance">
              <Accordion.Header>
                <span className="me-2 icn">
                  {" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M6.00001 2.39999C5.36349 2.39999 4.75304 2.65285 4.30295 3.10294C3.85286 3.55302 3.60001 4.16347 3.60001 4.79999V21.6L7.80001 19.2L12 21.6L16.2 19.2L20.4 21.6V4.79999C20.4 4.16347 20.1471 3.55302 19.6971 3.10294C19.247 2.65285 18.6365 2.39999 18 2.39999H6.00001ZM9.00001 5.99999C8.52262 5.99999 8.06478 6.18964 7.72721 6.5272C7.38965 6.86477 7.20001 7.3226 7.20001 7.79999C7.20001 8.27738 7.38965 8.73522 7.72721 9.07279C8.06478 9.41035 8.52262 9.59999 9.00001 9.59999C9.4774 9.59999 9.93523 9.41035 10.2728 9.07279C10.6104 8.73522 10.8 8.27738 10.8 7.79999C10.8 7.3226 10.6104 6.86477 10.2728 6.5272C9.93523 6.18964 9.4774 5.99999 9.00001 5.99999ZM16.4484 6.35159C16.2234 6.12663 15.9182 6.00025 15.6 6.00025C15.2818 6.00025 14.9766 6.12663 14.7516 6.35159L7.55161 13.5516C7.43699 13.6623 7.34558 13.7947 7.28268 13.9411C7.21979 14.0875 7.18669 14.245 7.18531 14.4043C7.18392 14.5636 7.21428 14.7217 7.27462 14.8691C7.33496 15.0166 7.42406 15.1506 7.53673 15.2633C7.6494 15.3759 7.78339 15.465 7.93086 15.5254C8.07834 15.5857 8.23635 15.6161 8.39569 15.6147C8.55502 15.6133 8.71249 15.5802 8.85889 15.5173C9.0053 15.4544 9.13771 15.363 9.24841 15.2484L16.4484 8.04839C16.6734 7.82336 16.7997 7.51819 16.7997 7.19999C16.7997 6.8818 16.6734 6.57663 16.4484 6.35159ZM15 12C14.5226 12 14.0648 12.1896 13.7272 12.5272C13.3896 12.8648 13.2 13.3226 13.2 13.8C13.2 14.2774 13.3896 14.7352 13.7272 15.0728C14.0648 15.4104 14.5226 15.6 15 15.6C15.4774 15.6 15.9352 15.4104 16.2728 15.0728C16.6104 14.7352 16.8 14.2774 16.8 13.8C16.8 13.3226 16.6104 12.8648 16.2728 12.5272C15.9352 12.1896 15.4774 12 15 12Z"
                      fill="black"
                    />
                  </svg>
                </span>
                Financial Questionnaire
              </Accordion.Header>
              <Accordion.Body className="py-0">
                <ul className="list-unstyled ps-4 py-2 mb-0">
                  <li className="py-2">
                    <NavLink
                      to="/finance-configure"
                      onClick={closeSidebar}
                      className={subNavClass}
                    >
                      <span className="me-2 icn">
                        {" "}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M6.00001 2.39999C5.36349 2.39999 4.75304 2.65285 4.30295 3.10294C3.85286 3.55302 3.60001 4.16347 3.60001 4.79999V21.6L7.80001 19.2L12 21.6L16.2 19.2L20.4 21.6V4.79999C20.4 4.16347 20.1471 3.55302 19.6971 3.10294C19.247 2.65285 18.6365 2.39999 18 2.39999H6.00001ZM9.00001 5.99999C8.52262 5.99999 8.06478 6.18964 7.72721 6.5272C7.38965 6.86477 7.20001 7.3226 7.20001 7.79999C7.20001 8.27738 7.38965 8.73522 7.72721 9.07279C8.06478 9.41035 8.52262 9.59999 9.00001 9.59999C9.4774 9.59999 9.93523 9.41035 10.2728 9.07279C10.6104 8.73522 10.8 8.27738 10.8 7.79999C10.8 7.3226 10.6104 6.86477 10.2728 6.5272C9.93523 6.18964 9.4774 5.99999 9.00001 5.99999ZM16.4484 6.35159C16.2234 6.12663 15.9182 6.00025 15.6 6.00025C15.2818 6.00025 14.9766 6.12663 14.7516 6.35159L7.55161 13.5516C7.43699 13.6623 7.34558 13.7947 7.28268 13.9411C7.21979 14.0875 7.18669 14.245 7.18531 14.4043C7.18392 14.5636 7.21428 14.7217 7.27462 14.8691C7.33496 15.0166 7.42406 15.1506 7.53673 15.2633C7.6494 15.3759 7.78339 15.465 7.93086 15.5254C8.07834 15.5857 8.23635 15.6161 8.39569 15.6147C8.55502 15.6133 8.71249 15.5802 8.85889 15.5173C9.0053 15.4544 9.13771 15.363 9.24841 15.2484L16.4484 8.04839C16.6734 7.82336 16.7997 7.51819 16.7997 7.19999C16.7997 6.8818 16.6734 6.57663 16.4484 6.35159ZM15 12C14.5226 12 14.0648 12.1896 13.7272 12.5272C13.3896 12.8648 13.2 13.3226 13.2 13.8C13.2 14.2774 13.3896 14.7352 13.7272 15.0728C14.0648 15.4104 14.5226 15.6 15 15.6C15.4774 15.6 15.9352 15.4104 16.2728 15.0728C16.6104 14.7352 16.8 14.2774 16.8 13.8C16.8 13.3226 16.6104 12.8648 16.2728 12.5272C15.9352 12.1896 15.4774 12 15 12Z"
                            fill="black"
                          />
                        </svg>
                      </span>
                      Financial Configuration
                    </NavLink>
                  </li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </li>
      )}

      {/* SOCIAL SUBSCRIBERS */}
      <li>
        <Accordion flush>
          <Accordion.Item eventKey="social">
            <Accordion.Header>
              <span className="me-2 icn">
                {" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M19.5 1.5H6C5.60218 1.5 5.22064 1.65804 4.93934 1.93934C4.65804 2.22064 4.5 2.60218 4.5 3V6H3V7.5H4.5V11.25H3V12.75H4.5V16.5H3V18H4.5V21C4.5 21.3978 4.65804 21.7794 4.93934 22.0607C5.22064 22.342 5.60218 22.5 6 22.5H19.5C19.8978 22.5 20.2794 22.342 20.5607 22.0607C20.842 21.7794 21 21.3978 21 21V3C21 2.60218 20.842 2.22064 20.5607 1.93934C20.2794 1.65804 19.8978 1.5 19.5 1.5ZM19.5 21H6V18H7.5V16.5H6V12.75H7.5V11.25H6V7.5H7.5V6H6V3H19.5V21Z"
                    fill="black"
                  />
                  <path
                    d="M10.5 6H16.5V7.5H10.5V6ZM10.5 11.25H16.5V12.75H10.5V11.25ZM10.5 16.5H16.5V18H10.5V16.5Z"
                    fill="black"
                  />
                </svg>
              </span>
              Social Subscribers
            </Accordion.Header>
            <Accordion.Body className="py-0">
              <ul className="list-unstyled ps-4 py-2 mb-0">
                {PERMISSIONS.includes("facebook") && (
                  <li className="py-2">
                    <NavLink
                      to="/facebook-messages"
                      onClick={closeSidebar}
                      className={subNavClass}
                    >
                      <span className="me-2 icn">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="11"
                          height="20"
                          viewBox="0 0 11 20"
                          fill="none"
                        >
                          <path
                            d="M7 11.5H9.5L10.5 7.5H7V5.5C7 4.47 7 3.5 9 3.5H10.5V0.14C10.174 0.0970001 8.943 0 7.643 0C4.928 0 3 1.657 3 4.7V7.5H0V11.5H3V20H7V11.5Z"
                            fill="#2E2E2E"
                          />
                        </svg>
                      </span>
                      Facebook Messages
                    </NavLink>
                  </li>
                )}

                {PERMISSIONS.includes("instagram") && (
                  <li className="py-2">
                    <NavLink
                      to="/instagram-messages"
                      onClick={closeSidebar}
                      className={subNavClass}
                    >
                      <span className="me-2 icn">
                        {" "}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <g clip-path="url(#clip0_2_6)">
                            <path
                              d="M8 0C5.829 0 5.556 0.01 4.703 0.048C3.85 0.088 3.269 0.222 2.76 0.42C2.22609 0.620819 1.74249 0.935826 1.343 1.343C0.936076 1.7427 0.621107 2.22624 0.42 2.76C0.222 3.268 0.087 3.85 0.048 4.7C0.01 5.555 0 5.827 0 8.001C0 10.173 0.01 10.445 0.048 11.298C0.088 12.15 0.222 12.731 0.42 13.24C0.625 13.766 0.898 14.212 1.343 14.657C1.787 15.102 2.233 15.376 2.759 15.58C3.269 15.778 3.849 15.913 4.701 15.952C5.555 15.99 5.827 16 8 16C10.173 16 10.444 15.99 11.298 15.952C12.149 15.912 12.732 15.778 13.241 15.58C13.7746 15.3791 14.2578 15.0641 14.657 14.657C15.102 14.212 15.375 13.766 15.58 13.24C15.777 12.731 15.912 12.15 15.952 11.298C15.99 10.445 16 10.173 16 8C16 5.827 15.99 5.555 15.952 4.701C15.912 3.85 15.777 3.268 15.58 2.76C15.3789 2.22623 15.0639 1.74268 14.657 1.343C14.2576 0.935676 13.774 0.620645 13.24 0.42C12.73 0.222 12.148 0.087 11.297 0.048C10.443 0.01 10.172 0 7.998 0H8.001H8ZM7.283 1.442H8.001C10.137 1.442 10.39 1.449 11.233 1.488C12.013 1.523 12.437 1.654 12.719 1.763C13.092 1.908 13.359 2.082 13.639 2.362C13.919 2.642 14.092 2.908 14.237 3.282C14.347 3.563 14.477 3.987 14.512 4.767C14.551 5.61 14.559 5.863 14.559 7.998C14.559 10.133 14.551 10.387 14.512 11.23C14.477 12.01 14.346 12.433 14.237 12.715C14.1087 13.0624 13.904 13.3764 13.638 13.634C13.358 13.914 13.092 14.087 12.718 14.232C12.438 14.342 12.014 14.472 11.233 14.508C10.39 14.546 10.137 14.555 8.001 14.555C5.865 14.555 5.611 14.546 4.768 14.508C3.988 14.472 3.565 14.342 3.283 14.232C2.9355 14.1039 2.62113 13.8996 2.363 13.634C2.09675 13.376 1.89172 13.0617 1.763 12.714C1.654 12.433 1.523 12.009 1.488 11.229C1.45 10.386 1.442 10.133 1.442 7.996C1.442 5.86 1.45 5.608 1.488 4.765C1.524 3.985 1.654 3.561 1.764 3.279C1.909 2.906 2.083 2.639 2.363 2.359C2.643 2.079 2.909 1.906 3.283 1.761C3.565 1.651 3.988 1.521 4.768 1.485C5.506 1.451 5.792 1.441 7.283 1.44V1.442ZM12.271 2.77C12.1449 2.77 12.0201 2.79483 11.9036 2.84308C11.7872 2.89132 11.6813 2.96203 11.5922 3.05118C11.503 3.14032 11.4323 3.24615 11.3841 3.36262C11.3358 3.4791 11.311 3.60393 11.311 3.73C11.311 3.85607 11.3358 3.9809 11.3841 4.09738C11.4323 4.21385 11.503 4.31968 11.5922 4.40882C11.6813 4.49797 11.7872 4.56868 11.9036 4.61692C12.0201 4.66517 12.1449 4.69 12.271 4.69C12.5256 4.69 12.7698 4.58886 12.9498 4.40882C13.1299 4.22879 13.231 3.98461 13.231 3.73C13.231 3.47539 13.1299 3.23121 12.9498 3.05118C12.7698 2.87114 12.5256 2.77 12.271 2.77ZM8.001 3.892C7.45607 3.8835 6.91489 3.98349 6.40898 4.18614C5.90306 4.3888 5.44251 4.69007 5.05415 5.07242C4.66579 5.45478 4.35736 5.91057 4.14684 6.41326C3.93632 6.91595 3.8279 7.4555 3.8279 8.0005C3.8279 8.5455 3.93632 9.08505 4.14684 9.58774C4.35736 10.0904 4.66579 10.5462 5.05415 10.9286C5.44251 11.3109 5.90306 11.6122 6.40898 11.8149C6.91489 12.0175 7.45607 12.1175 8.001 12.109C9.07954 12.0922 10.1082 11.6519 10.865 10.8833C11.6217 10.1146 12.0459 9.07917 12.0459 8.0005C12.0459 6.92183 11.6217 5.88641 10.865 5.11775C10.1082 4.34909 9.07954 3.90883 8.001 3.892ZM8.001 5.333C8.70833 5.333 9.38669 5.61399 9.88685 6.11415C10.387 6.61431 10.668 7.29267 10.668 8C10.668 8.70733 10.387 9.38569 9.88685 9.88585C9.38669 10.386 8.70833 10.667 8.001 10.667C7.29367 10.667 6.61531 10.386 6.11515 9.88585C5.61499 9.38569 5.334 8.70733 5.334 8C5.334 7.29267 5.61499 6.61431 6.11515 6.11415C6.61531 5.61399 7.29367 5.333 8.001 5.333Z"
                              fill="#2E2E2E"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_2_6">
                              <rect width="16" height="16" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </span>
                      Instagram Messages
                    </NavLink>
                  </li>
                )}

                {PERMISSIONS.includes("twitter") && (
                  <li className="py-2">
                    <NavLink
                      to="/twitter-messages"
                      onClick={closeSidebar}
                      className={subNavClass}
                    >
                      <span className="me-2 icn">
                        {" "}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M22.46 6C21.69 6.35 20.86 6.58 20 6.69C20.88 6.16 21.56 5.32 21.88 4.31C21.05 4.81 20.13 5.16 19.16 5.36C18.37 4.5 17.26 4 16 4C13.65 4 11.73 5.92 11.73 8.29C11.73 8.63 11.77 8.96 11.84 9.27C8.28001 9.09 5.11001 7.38 3.00001 4.79C2.63001 5.42 2.42001 6.16 2.42001 6.94C2.42001 8.43 3.17001 9.75 4.33001 10.5C3.62001 10.5 2.96001 10.3 2.38001 10V10.03C2.38001 12.11 3.86001 13.85 5.82001 14.24C5.19074 14.4122 4.5301 14.4362 3.89001 14.31C4.16162 15.1625 4.69355 15.9084 5.41103 16.4429C6.1285 16.9775 6.99546 17.2737 7.89001 17.29C6.37364 18.4904 4.494 19.1393 2.56001 19.13C2.22001 19.13 1.88001 19.11 1.54001 19.07C3.44001 20.29 5.70001 21 8.12001 21C16 21 20.33 14.46 20.33 8.79C20.33 8.6 20.33 8.42 20.32 8.23C21.16 7.63 21.88 6.87 22.46 6Z"
                            fill="#2E2E2E"
                          />
                        </svg>
                      </span>
                      Twitter Messages
                    </NavLink>
                  </li>
                )}

                {PERMISSIONS.includes("youtube") && (
                  <li className="py-2">
                    <NavLink
                      to="/youtube-messages"
                      onClick={closeSidebar}
                      className={subNavClass}
                    >
                      <span className="me-2 icn">
                        {" "}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M10 15L15.19 12L10 9V15ZM21.56 7.17C21.69 7.64 21.78 8.27 21.84 9.07C21.91 9.87 21.94 10.56 21.94 11.16L22 12C22 14.19 21.84 15.8 21.56 16.83C21.31 17.73 20.73 18.31 19.83 18.56C19.36 18.69 18.5 18.78 17.18 18.84C15.88 18.91 14.69 18.94 13.59 18.94L12 19C7.81 19 5.2 18.84 4.17 18.56C3.27 18.31 2.69 17.73 2.44 16.83C2.31 16.36 2.22 15.73 2.16 14.93C2.09 14.13 2.06 13.44 2.06 12.84L2 12C2 9.81 2.16 8.2 2.44 7.17C2.69 6.27 3.27 5.69 4.17 5.44C4.64 5.31 5.5 5.22 6.82 5.16C8.12 5.09 9.31 5.06 10.41 5.06L12 5C16.19 5 18.8 5.16 19.83 5.44C20.73 5.69 21.31 6.27 21.56 7.17Z"
                            fill="#2E2E2E"
                          />
                        </svg>
                      </span>
                      Youtube Messages
                    </NavLink>
                  </li>
                )}

                {PERMISSIONS.includes("tiktok") && (
                  <li className="py-2">
                    <NavLink
                      to="/tiktok-messages"
                      onClick={closeSidebar}
                      className={subNavClass}
                    >
                      <span className="me-2 icn">
                        {" "}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M16.6 5.82C15.9165 5.03962 15.5397 4.03743 15.54 3H12.45V15.4C12.4262 16.071 12.1429 16.7066 11.6598 17.1729C11.1767 17.6393 10.5315 17.8999 9.86003 17.9C8.44003 17.9 7.26003 16.74 7.26003 15.3C7.26003 13.58 8.92003 12.29 10.63 12.82V9.66C7.18003 9.2 4.16003 11.88 4.16003 15.3C4.16003 18.63 6.92003 21 9.85003 21C12.99 21 15.54 18.45 15.54 15.3V9.01C16.793 9.90985 18.2974 10.3926 19.84 10.39V7.3C19.84 7.3 17.96 7.39 16.6 5.82Z"
                            fill="black"
                          />
                        </svg>
                      </span>
                      Tiktok Messages
                    </NavLink>
                  </li>
                )}
              </ul>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </li>

      {/* CONTACT MESSAGES */}
      {PERMISSIONS.includes("contact_messages") && (
        <li>
          <NavLink
            to="/contact-messages"
            onClick={closeSidebar}
            className={navClass}
          >
            <span className="me-2 icn">
              {" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <path
                  d="M4.66699 6.41669C4.83227 6.41669 4.97091 6.36069 5.08291 6.24869C5.19491 6.13669 5.25071 5.99824 5.25033 5.83335C5.25033 5.66808 5.19433 5.52944 5.08233 5.41744C4.97033 5.30544 4.83188 5.24963 4.66699 5.25002C4.50171 5.25002 4.36308 5.30602 4.25108 5.41802C4.13908 5.53002 4.08327 5.66847 4.08366 5.83335C4.08366 5.99863 4.13966 6.13727 4.25166 6.24927C4.36366 6.36127 4.5021 6.41708 4.66699 6.41669ZM7.00033 6.41669C7.1656 6.41669 7.30424 6.36069 7.41624 6.24869C7.52824 6.13669 7.58405 5.99824 7.58366 5.83335C7.58366 5.66808 7.52766 5.52944 7.41566 5.41744C7.30366 5.30544 7.16521 5.24963 7.00033 5.25002C6.83505 5.25002 6.69641 5.30602 6.58441 5.41802C6.47241 5.53002 6.4166 5.66847 6.41699 5.83335C6.41699 5.99863 6.47299 6.13727 6.58499 6.24927C6.69699 6.36127 6.83544 6.41708 7.00033 6.41669ZM9.33366 6.41669C9.49894 6.41669 9.63757 6.36069 9.74957 6.24869C9.86157 6.13669 9.91738 5.99824 9.91699 5.83335C9.91699 5.66808 9.86099 5.52944 9.74899 5.41744C9.63699 5.30544 9.49855 5.24963 9.33366 5.25002C9.16838 5.25002 9.02974 5.30602 8.91774 5.41802C8.80574 5.53002 8.74994 5.66847 8.75033 5.83335C8.75033 5.99863 8.80633 6.13727 8.91833 6.24927C9.03033 6.36127 9.16877 6.41708 9.33366 6.41669ZM1.16699 12.8334V2.33335C1.16699 2.01252 1.28133 1.73777 1.50999 1.5091C1.73866 1.28044 2.01321 1.1663 2.33366 1.16669H11.667C11.9878 1.16669 12.2626 1.28102 12.4912 1.50969C12.7199 1.73835 12.834 2.01291 12.8337 2.33335V9.33335C12.8337 9.65419 12.7193 9.92894 12.4907 10.1576C12.262 10.3863 11.9874 10.5004 11.667 10.5H3.50033L1.16699 12.8334Z"
                  fill="black"
                />
              </svg>
            </span>
            Contact Messages
          </NavLink>
        </li>
      )}

      {/* SUBSCRIBERS */}
      {PERMISSIONS.includes("subscribers") && (
        <li>
          <NavLink
            to="/subscribers"
            onClick={closeSidebar}
            className={navClass}
          >
            <span className="me-2 icn">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M4.01 6.00999H20.01V8.00999H4.01V6.00999ZM6.01 2.00999H18.01V4.00999H6.01V2.00999ZM20 9.99999H4C3.46957 9.99999 2.96086 10.2107 2.58579 10.5858C2.21071 10.9609 2 11.4696 2 12V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H20C20.5304 22 21.0391 21.7893 21.4142 21.4142C21.7893 21.0391 22 20.5304 22 20V12C22 11.4696 21.7893 10.9609 21.4142 10.5858C21.0391 10.2107 20.5304 9.99999 20 9.99999ZM10.3 20L7 16.76L8.4 15.36L10.3 17.26L15.6 11.96L17 13.36L10.3 20Z"
                  fill="black"
                />
              </svg>
            </span>
            Subscribers
          </NavLink>
        </li>
      )}

      {/* SUB ADMINS */}
      {PERMISSIONS.includes("sub_admin") && (
        <li>
          <NavLink to="/subadmins" onClick={closeSidebar} className={navClass}>
            <span className="me-2 icn">
              {" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M6.00001 2.39999C5.36349 2.39999 4.75304 2.65285 4.30295 3.10294C3.85286 3.55302 3.60001 4.16347 3.60001 4.79999V21.6L7.80001 19.2L12 21.6L16.2 19.2L20.4 21.6V4.79999C20.4 4.16347 20.1471 3.55302 19.6971 3.10294C19.247 2.65285 18.6365 2.39999 18 2.39999H6.00001ZM9.00001 5.99999C8.52262 5.99999 8.06478 6.18964 7.72721 6.5272C7.38965 6.86477 7.20001 7.3226 7.20001 7.79999C7.20001 8.27738 7.38965 8.73522 7.72721 9.07279C8.06478 9.41035 8.52262 9.59999 9.00001 9.59999C9.4774 9.59999 9.93523 9.41035 10.2728 9.07279C10.6104 8.73522 10.8 8.27738 10.8 7.79999C10.8 7.3226 10.6104 6.86477 10.2728 6.5272C9.93523 6.18964 9.4774 5.99999 9.00001 5.99999ZM16.4484 6.35159C16.2234 6.12663 15.9182 6.00025 15.6 6.00025C15.2818 6.00025 14.9766 6.12663 14.7516 6.35159L7.55161 13.5516C7.43699 13.6623 7.34558 13.7947 7.28268 13.9411C7.21979 14.0875 7.18669 14.245 7.18531 14.4043C7.18392 14.5636 7.21428 14.7217 7.27462 14.8691C7.33496 15.0166 7.42406 15.1506 7.53673 15.2633C7.6494 15.3759 7.78339 15.465 7.93086 15.5254C8.07834 15.5857 8.23635 15.6161 8.39569 15.6147C8.55502 15.6133 8.71249 15.5802 8.85889 15.5173C9.0053 15.4544 9.13771 15.363 9.24841 15.2484L16.4484 8.04839C16.6734 7.82336 16.7997 7.51819 16.7997 7.19999C16.7997 6.8818 16.6734 6.57663 16.4484 6.35159ZM15 12C14.5226 12 14.0648 12.1896 13.7272 12.5272C13.3896 12.8648 13.2 13.3226 13.2 13.8C13.2 14.2774 13.3896 14.7352 13.7272 15.0728C14.0648 15.4104 14.5226 15.6 15 15.6C15.4774 15.6 15.9352 15.4104 16.2728 15.0728C16.6104 14.7352 16.8 14.2774 16.8 13.8C16.8 13.3226 16.6104 12.8648 16.2728 12.5272C15.9352 12.1896 15.4774 12 15 12Z"
                  fill="black"
                />
              </svg>
            </span>
            Manage Teams
          </NavLink>
        </li>
      )}
      <li>
        <Accordion>
          <Accordion.Item eventKey="settings">
            <Accordion.Header>
              <span className="me-2 icn">
                {" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M19.5 1.5H6C5.60218 1.5 5.22064 1.65804 4.93934 1.93934C4.65804 2.22064 4.5 2.60218 4.5 3V6H3V7.5H4.5V11.25H3V12.75H4.5V16.5H3V18H4.5V21C4.5 21.3978 4.65804 21.7794 4.93934 22.0607C5.22064 22.342 5.60218 22.5 6 22.5H19.5C19.8978 22.5 20.2794 22.342 20.5607 22.0607C20.842 21.7794 21 21.3978 21 21V3C21 2.60218 20.842 2.22064 20.5607 1.93934C20.2794 1.65804 19.8978 1.5 19.5 1.5ZM19.5 21H6V18H7.5V16.5H6V12.75H7.5V11.25H6V7.5H7.5V6H6V3H19.5V21Z"
                    fill="black"
                  />
                  <path
                    d="M10.5 6H16.5V7.5H10.5V6ZM10.5 11.25H16.5V12.75H10.5V11.25ZM10.5 16.5H16.5V18H10.5V16.5Z"
                    fill="black"
                  />
                </svg>
              </span>
              Settings
            </Accordion.Header>

            <Accordion.Body className="py-0">
              <ul className="list-unstyled ps-4 mb-0 py-2">
                {PERMISSIONS.includes("documents") && (
                  <li className="py-2">
                    <NavLink
                      to="/documents"
                      className={linkClass}
                      onClick={() => setShowSidebar(false)}
                    >
                      <span className="me-2 icn">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M18 16H16V15H8V16H6V15H2V20H22V15H18V16ZM20 8H17V6C17 4.9 16.1 4 15 4H9C7.9 4 7 4.9 7 6V8H4C2.9 8 2 8.9 2 10V14H6V12H8V14H16V12H18V14H22V10C22 8.9 21.1 8 20 8ZM15 8H9V6H15V8Z"
                            fill="black"
                          />
                        </svg>
                      </span>
                      Documents
                    </NavLink>
                  </li>
                )}

                {PERMISSIONS.includes("template_categories") && (
                  <li className="py-2">
                    <NavLink
                      to="/temp-categories"
                      className={linkClass}
                      onClick={() => setShowSidebar(false)}
                    >
                      <span className="icn me-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="15"
                          viewBox="0 0 15 15"
                          fill="none"
                        >
                          <path
                            d="M6.875 11.25H8.125V9.375H10V8.125H8.125V6.25H6.875V8.125H5V9.375H6.875V11.25ZM2.5 13.75C2.15625 13.75 1.86208 13.6277 1.6175 13.3831C1.3725 13.1381 1.25 12.8438 1.25 12.5V5C1.25 4.65625 1.3725 4.36208 1.6175 4.1175C1.86208 3.8725 2.15625 3.75 2.5 3.75H5V2.5C5 2.15625 5.1225 1.86187 5.3675 1.61687C5.61208 1.37229 5.90625 1.25 6.25 1.25H8.75C9.09375 1.25 9.38813 1.37229 9.63313 1.61687C9.87771 1.86187 10 2.15625 10 2.5V3.75H12.5C12.8438 3.75 13.1381 3.8725 13.3831 4.1175C13.6277 4.36208 13.75 4.65625 13.75 5V12.5C13.75 12.8438 13.6277 13.1381 13.3831 13.3831C13.1381 13.6277 12.8438 13.75 12.5 13.75H2.5ZM2.5 12.5H12.5V5H2.5V12.5ZM6.25 3.75H8.75V2.5H6.25V3.75ZM2.5 12.5V5V12.5Z"
                            fill="black"
                          />
                        </svg>
                      </span>{" "}
                      Template Categories
                    </NavLink>
                  </li>
                )}

                {PERMISSIONS.includes("document_categories") && (
                  <li className="py-2">
                    <NavLink
                      to="/doc-categories"
                      className={linkClass}
                      onClick={() => setShowSidebar(false)}
                    >
                      <span className="icn me-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="15"
                          viewBox="0 0 15 15"
                          fill="none"
                        >
                          <path
                            d="M6.875 11.25H8.125V9.375H10V8.125H8.125V6.25H6.875V8.125H5V9.375H6.875V11.25ZM2.5 13.75C2.15625 13.75 1.86208 13.6277 1.6175 13.3831C1.3725 13.1381 1.25 12.8438 1.25 12.5V5C1.25 4.65625 1.3725 4.36208 1.6175 4.1175C1.86208 3.8725 2.15625 3.75 2.5 3.75H5V2.5C5 2.15625 5.1225 1.86187 5.3675 1.61687C5.61208 1.37229 5.90625 1.25 6.25 1.25H8.75C9.09375 1.25 9.38813 1.37229 9.63313 1.61687C9.87771 1.86187 10 2.15625 10 2.5V3.75H12.5C12.8438 3.75 13.1381 3.8725 13.3831 4.1175C13.6277 4.36208 13.75 4.65625 13.75 5V12.5C13.75 12.8438 13.6277 13.1381 13.3831 13.3831C13.1381 13.6277 12.8438 13.75 12.5 13.75H2.5ZM2.5 12.5H12.5V5H2.5V12.5ZM6.25 3.75H8.75V2.5H6.25V3.75ZM2.5 12.5V5V12.5Z"
                            fill="black"
                          />
                        </svg>
                      </span>{" "}
                      Quick Packs
                    </NavLink>
                  </li>
                )}

                {PERMISSIONS.includes("email_template") && (
                  <li className="py-2">
                    <NavLink
                      to="/email-templates"
                      className={linkClass}
                      onClick={() => setShowSidebar(false)}
                    >
                      <span className="icn me-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="15"
                          viewBox="0 0 15 15"
                          fill="none"
                        >
                          <path
                            d="M6.875 11.25H8.125V9.375H10V8.125H8.125V6.25H6.875V8.125H5V9.375H6.875V11.25ZM2.5 13.75C2.15625 13.75 1.86208 13.6277 1.6175 13.3831C1.3725 13.1381 1.25 12.8438 1.25 12.5V5C1.25 4.65625 1.3725 4.36208 1.6175 4.1175C1.86208 3.8725 2.15625 3.75 2.5 3.75H5V2.5C5 2.15625 5.1225 1.86187 5.3675 1.61687C5.61208 1.37229 5.90625 1.25 6.25 1.25H8.75C9.09375 1.25 9.38813 1.37229 9.63313 1.61687C9.87771 1.86187 10 2.15625 10 2.5V3.75H12.5C12.8438 3.75 13.1381 3.8725 13.3831 4.1175C13.6277 4.36208 13.75 4.65625 13.75 5V12.5C13.75 12.8438 13.6277 13.1381 13.3831 13.3831C13.1381 13.6277 12.8438 13.75 12.5 13.75H2.5ZM2.5 12.5H12.5V5H2.5V12.5ZM6.25 3.75H8.75V2.5H6.25V3.75ZM2.5 12.5V5V12.5Z"
                            fill="black"
                          />
                        </svg>
                      </span>{" "}
                      Email Template
                    </NavLink>
                  </li>
                )}

                {PERMISSIONS.includes("sms_template") && (
                  <li className="py-2">
                    <NavLink
                      to="/sms-templates"
                      className={linkClass}
                      onClick={() => setShowSidebar(false)}
                    >
                      <span className="icn me-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="15"
                          viewBox="0 0 15 15"
                          fill="none"
                        >
                          <path
                            d="M6.875 11.25H8.125V9.375H10V8.125H8.125V6.25H6.875V8.125H5V9.375H6.875V11.25ZM2.5 13.75C2.15625 13.75 1.86208 13.6277 1.6175 13.3831C1.3725 13.1381 1.25 12.8438 1.25 12.5V5C1.25 4.65625 1.3725 4.36208 1.6175 4.1175C1.86208 3.8725 2.15625 3.75 2.5 3.75H5V2.5C5 2.15625 5.1225 1.86187 5.3675 1.61687C5.61208 1.37229 5.90625 1.25 6.25 1.25H8.75C9.09375 1.25 9.38813 1.37229 9.63313 1.61687C9.87771 1.86187 10 2.15625 10 2.5V3.75H12.5C12.8438 3.75 13.1381 3.8725 13.3831 4.1175C13.6277 4.36208 13.75 4.65625 13.75 5V12.5C13.75 12.8438 13.6277 13.1381 13.3831 13.3831C13.1381 13.6277 12.8438 13.75 12.5 13.75H2.5ZM2.5 12.5H12.5V5H2.5V12.5ZM6.25 3.75H8.75V2.5H6.25V3.75ZM2.5 12.5V5V12.5Z"
                            fill="black"
                          />
                        </svg>
                      </span>{" "}
                      SMS Template
                    </NavLink>
                  </li>
                )}

                {PERMISSIONS.includes("document_template") && (
                  <li className="py-2">
                    <NavLink
                      to="/templates"
                      className={linkClass}
                      onClick={() => setShowSidebar(false)}
                    >
                      <span className="icn me-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="15"
                          viewBox="0 0 15 15"
                          fill="none"
                        >
                          <path
                            d="M6.875 11.25H8.125V9.375H10V8.125H8.125V6.25H6.875V8.125H5V9.375H6.875V11.25ZM2.5 13.75C2.15625 13.75 1.86208 13.6277 1.6175 13.3831C1.3725 13.1381 1.25 12.8438 1.25 12.5V5C1.25 4.65625 1.3725 4.36208 1.6175 4.1175C1.86208 3.8725 2.15625 3.75 2.5 3.75H5V2.5C5 2.15625 5.1225 1.86187 5.3675 1.61687C5.61208 1.37229 5.90625 1.25 6.25 1.25H8.75C9.09375 1.25 9.38813 1.37229 9.63313 1.61687C9.87771 1.86187 10 2.15625 10 2.5V3.75H12.5C12.8438 3.75 13.1381 3.8725 13.3831 4.1175C13.6277 4.36208 13.75 4.65625 13.75 5V12.5C13.75 12.8438 13.6277 13.1381 13.3831 13.3831C13.1381 13.6277 12.8438 13.75 12.5 13.75H2.5ZM2.5 12.5H12.5V5H2.5V12.5ZM6.25 3.75H8.75V2.5H6.25V3.75ZM2.5 12.5V5V12.5Z"
                            fill="black"
                          />
                        </svg>
                      </span>{" "}
                      Document Template
                    </NavLink>
                  </li>
                )}

                {PERMISSIONS.includes("email_signature") && (
                  <li className="py-2">
                    <NavLink
                      to="/email-signature"
                      className={linkClass}
                      onClick={() => setShowSidebar(false)}
                    >
                      <span className="icn me-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="15"
                          viewBox="0 0 15 15"
                          fill="none"
                        >
                          <path
                            d="M6.875 11.25H8.125V9.375H10V8.125H8.125V6.25H6.875V8.125H5V9.375H6.875V11.25ZM2.5 13.75C2.15625 13.75 1.86208 13.6277 1.6175 13.3831C1.3725 13.1381 1.25 12.8438 1.25 12.5V5C1.25 4.65625 1.3725 4.36208 1.6175 4.1175C1.86208 3.8725 2.15625 3.75 2.5 3.75H5V2.5C5 2.15625 5.1225 1.86187 5.3675 1.61687C5.61208 1.37229 5.90625 1.25 6.25 1.25H8.75C9.09375 1.25 9.38813 1.37229 9.63313 1.61687C9.87771 1.86187 10 2.15625 10 2.5V3.75H12.5C12.8438 3.75 13.1381 3.8725 13.3831 4.1175C13.6277 4.36208 13.75 4.65625 13.75 5V12.5C13.75 12.8438 13.6277 13.1381 13.3831 13.3831C13.1381 13.6277 12.8438 13.75 12.5 13.75H2.5ZM2.5 12.5H12.5V5H2.5V12.5ZM6.25 3.75H8.75V2.5H6.25V3.75ZM2.5 12.5V5V12.5Z"
                            fill="black"
                          />
                        </svg>
                      </span>{" "}
                      Email Signature
                    </NavLink>
                  </li>
                )}

                {PERMISSIONS.includes("notification_settings") && (
                  <li className="py-2">
                    <NavLink
                      to="/notification-settings"
                      className={linkClass}
                      onClick={() => setShowSidebar(false)}
                    >
                      <span className="icn me-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="15"
                          viewBox="0 0 15 15"
                          fill="none"
                        >
                          <path
                            d="M6.875 11.25H8.125V9.375H10V8.125H8.125V6.25H6.875V8.125H5V9.375H6.875V11.25ZM2.5 13.75C2.15625 13.75 1.86208 13.6277 1.6175 13.3831C1.3725 13.1381 1.25 12.8438 1.25 12.5V5C1.25 4.65625 1.3725 4.36208 1.6175 4.1175C1.86208 3.8725 2.15625 3.75 2.5 3.75H5V2.5C5 2.15625 5.1225 1.86187 5.3675 1.61687C5.61208 1.37229 5.90625 1.25 6.25 1.25H8.75C9.09375 1.25 9.38813 1.37229 9.63313 1.61687C9.87771 1.86187 10 2.15625 10 2.5V3.75H12.5C12.8438 3.75 13.1381 3.8725 13.3831 4.1175C13.6277 4.36208 13.75 4.65625 13.75 5V12.5C13.75 12.8438 13.6277 13.1381 13.3831 13.3831C13.1381 13.6277 12.8438 13.75 12.5 13.75H2.5ZM2.5 12.5H12.5V5H2.5V12.5ZM6.25 3.75H8.75V2.5H6.25V3.75ZM2.5 12.5V5V12.5Z"
                            fill="black"
                          />
                        </svg>
                      </span>{" "}
                      Notification Settings
                    </NavLink>
                  </li>
                )}

                {PERMISSIONS.includes("basic_settings") && (
                  <li className="py-2">
                    <NavLink
                      to="/basic-settings"
                      className={linkClass}
                      onClick={() => setShowSidebar(false)}
                    >
                      <span className="icn me-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="15"
                          viewBox="0 0 15 15"
                          fill="none"
                        >
                          <path
                            d="M6.875 11.25H8.125V9.375H10V8.125H8.125V6.25H6.875V8.125H5V9.375H6.875V11.25ZM2.5 13.75C2.15625 13.75 1.86208 13.6277 1.6175 13.3831C1.3725 13.1381 1.25 12.8438 1.25 12.5V5C1.25 4.65625 1.3725 4.36208 1.6175 4.1175C1.86208 3.8725 2.15625 3.75 2.5 3.75H5V2.5C5 2.15625 5.1225 1.86187 5.3675 1.61687C5.61208 1.37229 5.90625 1.25 6.25 1.25H8.75C9.09375 1.25 9.38813 1.37229 9.63313 1.61687C9.87771 1.86187 10 2.15625 10 2.5V3.75H12.5C12.8438 3.75 13.1381 3.8725 13.3831 4.1175C13.6277 4.36208 13.75 4.65625 13.75 5V12.5C13.75 12.8438 13.6277 13.1381 13.3831 13.3831C13.1381 13.6277 12.8438 13.75 12.5 13.75H2.5ZM2.5 12.5H12.5V5H2.5V12.5ZM6.25 3.75H8.75V2.5H6.25V3.75ZM2.5 12.5V5V12.5Z"
                            fill="black"
                          />
                        </svg>
                      </span>{" "}
                      Basic Settings
                    </NavLink>
                  </li>
                )}
              </ul>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </li>

      {/* GENERATE EMBED */}
      {PERMISSIONS.includes("generate_embed_code") && (
        <li>
          <NavLink
            to="/generate-code"
            onClick={closeSidebar}
            className={navClass}
          >
            <span className="me-2 icn">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M6.00001 2.39999C5.36349 2.39999 4.75304 2.65285 4.30295 3.10294C3.85286 3.55302 3.60001 4.16347 3.60001 4.79999V21.6L7.80001 19.2L12 21.6L16.2 19.2L20.4 21.6V4.79999C20.4 4.16347 20.1471 3.55302 19.6971 3.10294C19.247 2.65285 18.6365 2.39999 18 2.39999H6.00001ZM9.00001 5.99999C8.52262 5.99999 8.06478 6.18964 7.72721 6.5272C7.38965 6.86477 7.20001 7.3226 7.20001 7.79999C7.20001 8.27738 7.38965 8.73522 7.72721 9.07279C8.06478 9.41035 8.52262 9.59999 9.00001 9.59999C9.4774 9.59999 9.93523 9.41035 10.2728 9.07279C10.6104 8.73522 10.8 8.27738 10.8 7.79999C10.8 7.3226 10.6104 6.86477 10.2728 6.5272C9.93523 6.18964 9.4774 5.99999 9.00001 5.99999ZM16.4484 6.35159C16.2234 6.12663 15.9182 6.00025 15.6 6.00025C15.2818 6.00025 14.9766 6.12663 14.7516 6.35159L7.55161 13.5516C7.43699 13.6623 7.34558 13.7947 7.28268 13.9411C7.21979 14.0875 7.18669 14.245 7.18531 14.4043C7.18392 14.5636 7.21428 14.7217 7.27462 14.8691C7.33496 15.0166 7.42406 15.1506 7.53673 15.2633C7.6494 15.3759 7.78339 15.465 7.93086 15.5254C8.07834 15.5857 8.23635 15.6161 8.39569 15.6147C8.55502 15.6133 8.71249 15.5802 8.85889 15.5173C9.0053 15.4544 9.13771 15.363 9.24841 15.2484L16.4484 8.04839C16.6734 7.82336 16.7997 7.51819 16.7997 7.19999C16.7997 6.8818 16.6734 6.57663 16.4484 6.35159ZM15 12C14.5226 12 14.0648 12.1896 13.7272 12.5272C13.3896 12.8648 13.2 13.3226 13.2 13.8C13.2 14.2774 13.3896 14.7352 13.7272 15.0728C14.0648 15.4104 14.5226 15.6 15 15.6C15.4774 15.6 15.9352 15.4104 16.2728 15.0728C16.6104 14.7352 16.8 14.2774 16.8 13.8C16.8 13.3226 16.6104 12.8648 16.2728 12.5272C15.9352 12.1896 15.4774 12 15 12Z"
                  fill="black"
                />
              </svg>
            </span>
            Generate Embed Code
          </NavLink>
        </li>
      )}

      <li>
        <Accordion>
          <Accordion.Item eventKey="insurance">
            <Accordion.Header>
              <span className="me-2 icn">
                {" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  class="__web-inspector-hide-shortcut__"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.8355 3.40001C11.268 3.13803 11.764 2.99953 12.2697 2.99953C12.7754 2.99953 13.2715 3.13803 13.704 3.40001L14.7225 4.02301C16.1515 4.89651 17.779 5.09101 19.414 5.28701C19.9425 5.35051 20.4715 5.41351 20.995 5.50001C20.995 5.50001 21.0065 6.41701 20.9945 6.83301L20.89 10.4085C20.8 13.475 19.4365 16.3825 17.0975 18.4955C15.994 19.492 14.8525 20.3925 13.541 21.1405C13.1545 21.3592 12.7211 21.4818 12.2774 21.4981C11.8336 21.5143 11.3925 21.4238 10.991 21.234C9.47649 20.514 8.13549 19.601 6.91099 18.4955C4.57199 16.3825 3.20849 13.475 3.11899 10.4085L3.01499 6.84451C3.00249 6.42201 3.01499 5.50001 3.01499 5.50001C3.43999 5.45001 3.87299 5.40851 4.30949 5.36701C6.23599 5.18401 8.22649 4.99501 9.85949 3.99701L10.836 3.40001H10.8355ZM11 11V7.50001H13V11H16.5V13H13V16.5H11V13H7.49999V11H11Z"
                    fill="black"
                  />
                </svg>
              </span>
              Insurance
            </Accordion.Header>

            <Accordion.Body className="py-0">
              <ul className="list-unstyled ps-4 mb-0 py-2">
                {PERMISSIONS.includes("health_insurance") && (
                  <li className="py-2">
                    <NavLink
                      to="/health-insurance"
                      className={linkClass}
                      onClick={() => setShowSidebar(false)}
                    >
                      <span className="icn me-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          class="__web-inspector-hide-shortcut__"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M8.962 18.469C6.019 16.214 2 12.489 2 8.967C2 3.083 7.5 0.886002 12 5.43C16.5 0.886002 22 3.083 22 8.966C22 12.489 17.98 16.214 15.038 18.469C13.706 19.489 13.04 20 12 20C10.96 20 10.294 19.49 8.962 18.469ZM16.5 6.25C16.6989 6.25 16.8897 6.32902 17.0303 6.46967C17.171 6.61032 17.25 6.80109 17.25 7V8.25H18.5C18.6989 8.25 18.8897 8.32902 19.0303 8.46967C19.171 8.61033 19.25 8.80109 19.25 9C19.25 9.19892 19.171 9.38968 19.0303 9.53033C18.8897 9.67098 18.6989 9.75 18.5 9.75H17.25V11C17.25 11.1989 17.171 11.3897 17.0303 11.5303C16.8897 11.671 16.6989 11.75 16.5 11.75C16.3011 11.75 16.1103 11.671 15.9697 11.5303C15.829 11.3897 15.75 11.1989 15.75 11V9.75H14.5C14.3011 9.75 14.1103 9.67098 13.9697 9.53033C13.829 9.38968 13.75 9.19892 13.75 9C13.75 8.80109 13.829 8.61033 13.9697 8.46967C14.1103 8.32902 14.3011 8.25 14.5 8.25H15.75V7C15.75 6.80109 15.829 6.61032 15.9697 6.46967C16.1103 6.32902 16.3011 6.25 16.5 6.25Z"
                            fill="black"
                          />
                        </svg>
                      </span>{" "}
                      Health Insurance
                    </NavLink>
                  </li>
                )}

                {PERMISSIONS.includes("life_insurance") && (
                  <li className="py-2">
                    <NavLink
                      to="/life-insurance"
                      className={linkClass}
                      onClick={() => setShowSidebar(false)}
                    >
                      <span className="icn me-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          class="__web-inspector-hide-shortcut__"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M8.962 18.469C6.019 16.214 2 12.489 2 8.967C2 3.083 7.5 0.886002 12 5.43C16.5 0.886002 22 3.083 22 8.966C22 12.489 17.98 16.214 15.038 18.469C13.706 19.489 13.04 20 12 20C10.96 20 10.294 19.49 8.962 18.469ZM16.5 6.25C16.6989 6.25 16.8897 6.32902 17.0303 6.46967C17.171 6.61032 17.25 6.80109 17.25 7V8.25H18.5C18.6989 8.25 18.8897 8.32902 19.0303 8.46967C19.171 8.61033 19.25 8.80109 19.25 9C19.25 9.19892 19.171 9.38968 19.0303 9.53033C18.8897 9.67098 18.6989 9.75 18.5 9.75H17.25V11C17.25 11.1989 17.171 11.3897 17.0303 11.5303C16.8897 11.671 16.6989 11.75 16.5 11.75C16.3011 11.75 16.1103 11.671 15.9697 11.5303C15.829 11.3897 15.75 11.1989 15.75 11V9.75H14.5C14.3011 9.75 14.1103 9.67098 13.9697 9.53033C13.829 9.38968 13.75 9.19892 13.75 9C13.75 8.80109 13.829 8.61033 13.9697 8.46967C14.1103 8.32902 14.3011 8.25 14.5 8.25H15.75V7C15.75 6.80109 15.829 6.61032 15.9697 6.46967C16.1103 6.32902 16.3011 6.25 16.5 6.25Z"
                            fill="black"
                          />
                        </svg>
                      </span>{" "}
                      Life Insurance
                    </NavLink>
                  </li>
                )}
              </ul>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </li>
    </ul>
  );
};

export default SubAdmin;
